import React from 'react';
import styled from 'styled-components'

const CopyrightComp: React.FC = () => {
  // const { setting } = useSetting();
  // const isFromArchitrave = useIsFromArchitrave();
  const currentYear = new Date().getFullYear();
  
  // const copyrightValue = isFromArchitrave
  //   ? `© ${currentYear} Architrave`
  //   : !setting?.username
  //     ? 'Architrave'
  //     : `Content © ${currentYear} ${setting.username}`;

  const copyrightValue = `© ${currentYear} Architrave`
  
  return (
    <GnbSection>
      <Copyright>{copyrightValue}</Copyright>
    </GnbSection>
  );
}

const GnbSection = styled.section`
  position: absolute;
  bottom: 0.5vw;
  right: 0.5vw;
  width: fit-content;
  height: fit-content;
  
  display: flex;
  align-items: center;
  background-color: transparent;

  user-select: none;
  z-index: 2;
`;

const Copyright = styled.div`
  color: ${({ theme }) => theme.colors.color_Gray_03};
  ${({ theme }) => theme.typography.Footer_01};
  user-select: none;
`;

export default CopyrightComp;
